import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

class FullPageContent extends Component {
    static propTypes = {
        children: PropTypes.any.isRequired,
        className: PropTypes.string
    };

    render() {
        const { children, className } = this.props;
        const classNames = cns('pageContent', 'container-fluid', className);
        return <div className={classNames}>{children}</div>;
    }
}

export default FullPageContent;
